import axios from 'axios';
import React, { useEffect } from 'react'
import API from '../../../../utils/API';
import { toast } from 'react-toastify';
import { motion, AnimatePresence } from "framer-motion";

export default function Slot() {
    const [allData, setAllData] = React.useState({});

    const batchSize = 10;
    const totalBatches = Math.ceil(allData?.data?.length / batchSize) || 1;

    // Create batches including an extra batch for remaining + 2 extra slots
    const batchNumbers = Array.from({ length: totalBatches + 1 }, (_, i) => i + 1);

    const [showAllAvailable, setShowAllAvailable] = React.useState(false);

    const getAllStudents = async () => {
        try {
            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.COLLEGE_GET_PAID_COLLEGES, {});
            setAllData(data);
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    useEffect(() => {
        getAllStudents();
    }, []);

    return (
        <div className='text-center mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 bg-[#F9FAFB] md:py-[50px] lg:py-[70px]' id='slot'>
            <p className='text-[28px] md:text-[40px] lg:text-[52px] font-bold text-center'>
                December Slots Just Opened
            </p>

            {batchNumbers.map((batchNo) => {
                const startIndex = (batchNo - 1) * batchSize;
                const endIndex = startIndex + batchSize;
                const batchData = allData?.data?.slice(startIndex, endIndex) || [];
                const bookedCount = batchData.length;

                // ------------------------------
                // EXTRA 2 SLOT LOGIC HERE
                // ------------------------------
                let displayedSlots = bookedCount + 2;

                // Cap at 100
                if (displayedSlots > batchSize) displayedSlots = batchSize;

                // If new batch and previous batch was full → show only 2 slots
                if (bookedCount === 0 && batchNo > 1) {
                    displayedSlots = 2;
                }

                const availableCount = displayedSlots - bookedCount;
                // ------------------------------

                if (batchNo > totalBatches && bookedCount === 0) return null;

                return (
                    <div key={batchNo} className="mt-[40px]">

                        {/* Heading */}
                        <p className="text-[24px] md:text-[32px] lg:text-[44px] font-bold text-[#101828] text-center"> {displayedSlots} Slots - {bookedCount === 0 ? "Just Opened" : bookedCount < displayedSlots ? "Almost Filled" : "Filled"} </p>

                        {/* Stats */}
                        <div className="mt-[10px] md:mt-[20px] flex justify-center items-center gap-[28px] text-[#4A5565] font-normal text-[14px]">
                            <div className="flex gap-[7px] items-center">
                                <div className="size-[10px] rounded-full bg-[#99A1AF]"></div>
                                <p>Available: {availableCount}</p>
                            </div>
                            <div className="flex gap-[7px] items-center">
                                <div className="size-[10px] rounded-full bg-[#27AE60]"></div>
                                <p>Booked: {bookedCount}</p>
                            </div>
                        </div>

                        {/* SLOT GRIDS */}
                        <div className="md:w-11/12 mx-auto mt-[10px] md:mt-[20px]">

                            {/* BOOKED CARDS */}
                            <div className="flex items-center justify-center gap-[15px] flex-wrap">
                                <AnimatePresence>
                                    {batchData.map((each, index) => (
                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, scale: 0.8 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.8 }}
                                            transition={{ duration: 0.3 }}
                                            className="xl:basis-[calc(14.28%-15px)] w-[140px] h-[170px] md:w-[184px] md:h-[200px] bg-[#DFFFD6] border border-[#F3E8FF] flex flex-col justify-center items-center p-[5px] rounded-[21px]"
                                            style={{ boxShadow: "0px 2px 4px 0px #0000001A" }}
                                        >
                                            <p className="text-[#228B22] font-bold text-[12px] md:text-[14px] py-[3px] md:py-[5px] px-[8px] md:px-[10px] border border-[#228B22] rounded-full">
                                                Booked
                                            </p>

                                            <p className="text-[#101828] font-semibold text-[12px] md:text-[14px] mt-[6px] md:mt-[8px]">
                                                Slot - {(batchNo - 1) * batchSize + index + 1}
                                            </p>

                                            <p className="mt-[4px] md:mt-[8px] text-[#101828] font-bold text-[13px] md:text-[15px] break-words whitespace-normal max-w-[120px] md:max-w-[168px]">
                                                {each?.institutionName}
                                            </p>
                                        </motion.div>
                                    ))}
                                </AnimatePresence>
                            </div>

                            {/* AVAILABLE CARDS */}
                            {availableCount > 0 && (
                                <div className="flex items-center justify-center gap-[15px] mt-[14px] md:mt-[28px] flex-wrap">

                                    {(() => {
                                        const visible = showAllAvailable
                                            ? availableCount
                                            : Math.min(3, availableCount);

                                        return (
                                            <AnimatePresence>
                                                {Array.from({ length: visible }).map((_, index) => (
                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, scale: 0.8 }}
                                                        animate={{ opacity: 1, scale: 1 }}
                                                        exit={{ opacity: 0, scale: 0.8 }}
                                                        transition={{ duration: 0.3 }}
                                                        className="xl:basis-[calc(14.28%-15px)] w-[140px] md:w-[184px] h-[100px] md:h-[134px] border border-[#34C759] flex flex-col justify-center items-center p-[5px] rounded-[16px] md:rounded-[21px] bg-[#34C7590D] cursor-pointer"
                                                        onClick={() => (window.location.href = "/surge-colleges/form")}
                                                    >
                                                        <p className="text-[#101828] font-semibold text-[12px] md:text-[14px]">
                                                            Slot - {(batchNo - 1) * batchSize + bookedCount + index + 1}
                                                        </p>

                                                        <p className="mt-[8px] text-[#34C759] font-semibold text-[16px] md:text-[18px]">
                                                            Book
                                                        </p>
                                                    </motion.div>
                                                ))}
                                            </AnimatePresence>
                                        );
                                    })()}

                                    {availableCount > 3 && (
                                        <div className='mt-[20px] md:mt-[30px] xl:mt-[54px] w-full grid md:flex md:justify-center md:items-center gap-[20px]'>
                                            <button
                                                className='bg-[#34C759] w-full md:w-[365px] h-[40px] md:h-[55px] lg:h-[82px] rounded-[10px] md:rounded-[22px] text-[#FFF] text-[14px] md:text-[18px] lg:text-[22px] font-semibold'
                                                onClick={() => setShowAllAvailable(!showAllAvailable)}
                                            >
                                                {showAllAvailable ? "Show Less" : "Show All Available"}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}

                        </div>
                    </div>
                );
            })}
        </div>
    )
}
